import { render, staticRenderFns } from "./AdminOfferDetail.vue?vue&type=template&id=4215cc5e&scoped=true&"
import script from "./AdminOfferDetail.vue?vue&type=script&lang=ts&"
export * from "./AdminOfferDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AdminOfferDetail.vue?vue&type=style&index=0&id=4215cc5e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4215cc5e",
  null
  
)

export default component.exports